export const convertSecondsToDays = (seconds: number): number => {
  return seconds / 60 / 60 / 24
}
